/**
 * The `/resourcegroup/*` routes reservations v2 calls (RESERVATIONS_V2_PLAN.md §4.6, RV1c), held to
 * the backend snapshot by `api/routes.test.ts`. The wire type is the backend's shape as read from
 * its code, so `api/` imports nothing from `tables/`.
 */
import { anySession } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

/** A group of tables, a section such as "Terrace" ("resource group" to the backend). */
export interface WireTableGroup {
  /** the group's id */
  mid: string;
  /** the group's name, such as "Terrace" */
  name: string;
  /** a longer description of the section, when one was written */
  description?: string;
  /** any other group field the backend stores */
  [field: string]: unknown;
}

/** The `/resourcegroup/*` route v2 calls: the branch's list of table sections. */
export const RESOURCEGROUP = defineRoutes("resourcegroup", {
  /** the groups of the branch's active tables */
  branchFetchAll: route<undefined, WireTableGroup[]>("GET", "/resourcegroup/branch/fetchAll", anySession(), {
    notes:
      "the groups of the token's branch's active tables; it reads no `branchId`. The backend registers it with `module:` (a typo) instead of `modules:`, so any signed-in session may call it (backend.md §6.1; resourcegroup_controller.js:20, :82-115)",
  }),
});
